export const COOLDOWN_MS = 120_000;
export const COOLDOWN_KEY = 'dashboard_snapshot_sync_until';
export const PENDING_WAIT_KEY = 'dashboard_snapshot_sync_pending';

export type PendingWait = { task_id: string; wait_until: number };

export type DashboardSnapshotSynced = {
    task_id?: string;
    status?: 'success' | 'failed' | string;
    error?: string | null;
    data?: {
        records_upserted?: number;
        dates_processed?: unknown;
        populated_at?: string;
    };
};

export type SyncSettledPayload = {
    status: 'success' | 'failed';
    error?: string | null;
    task_id?: string;
};

export const readPendingWait = (): PendingWait | null => {
    try {
        const raw = sessionStorage.getItem(PENDING_WAIT_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw) as PendingWait;
        if (!parsed?.task_id || !Number.isFinite(parsed.wait_until)) {
            sessionStorage.removeItem(PENDING_WAIT_KEY);
            return null;
        }
        if (Date.now() >= parsed.wait_until) {
            sessionStorage.removeItem(PENDING_WAIT_KEY);
            return null;
        }
        return parsed;
    } catch {
        sessionStorage.removeItem(PENDING_WAIT_KEY);
        return null;
    }
};

export const writePendingWait = (taskId: string, waitUntil: number) => {
    sessionStorage.setItem(
        PENDING_WAIT_KEY,
        JSON.stringify({ task_id: taskId, wait_until: waitUntil }),
    );
};

export const clearPendingWaitStorage = () => {
    sessionStorage.removeItem(PENDING_WAIT_KEY);
};

export const readCooldownUntil = () => {
    const raw = sessionStorage.getItem(COOLDOWN_KEY);
    const until = raw ? Number(raw) : 0;
    return Number.isFinite(until) ? until : 0;
};
